import { render, staticRenderFns } from "./klpiklanbaris.vue?vue&type=template&id=60c84a60"
import script from "./klpiklanbaris.vue?vue&type=script&lang=js"
export * from "./klpiklanbaris.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports